import { apiService } from "./apiService";

class PaymentService {
  async createBill(data) {
    try {
      const response = await apiService.post("/api/bills", {
        collection_id: process.env.REACT_APP_BILLPLZ_COLLECTION_ID,
        email: data.email,
        name: data.name,
        amount: data.amount, // Amount in cents
        callback_url: `${window.location.origin}/api/payment/callback`,
        redirect_url: `${window.location.origin}/payment/complete`,
        description: data.description || "Payment for services",
      });

      // Redirect to Billplz payment page
      if (response.url) {
        window.location.href = response.url;
      }

      return response;
    } catch (error) {
      console.error("Payment error:", error);
      throw error;
    }
  }

  async verifyPayment(billId) {
    try {
      const response = await apiService.get(`/api/bills/${billId}`);
      return response;
    } catch (error) {
      console.error("Payment verification error:", error);
      throw error;
    }
  }
}

export const paymentService = new PaymentService();
